/**
 * Heading Component
 */

import { getBackgroundColorClassName, getTextColorClassName } from '../../../styles/colors';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import LinkButton from '../../buttons/LinkButton';
import { Span } from '../Label';

interface IOwnProps extends IHyperlinkProps, ITextColorProps, IBackgroundColorProps, ILabelWithEllipsis {
  className?: string | string[] | { [id: string]: boolean };
  icon?: JSX.Element;
  is: HeadingType;
  noMargin?: boolean;
  style?: React.CSSProperties;
  WrappedComponent?: any;
}

export type HeadingProps = IOwnProps;

export default class Heading extends React.Component<IOwnProps, {}> {

  render() {
    const {
      backgroundColor,
      children,
      className,
      hyperLinkProps,
      icon,
      is,
      maxTextLength,
      noMargin,
      style,
      text,
      textColor,
    } = this.props;

    const WrappedComponent = this.props.WrappedComponent || is;
    const headingClass = classNames(
      getTextColorClassName(textColor),
      getBackgroundColorClassName(backgroundColor),
      { [is]: this.props.WrappedComponent },
      className,
    );

    const baseClass = !!!this.props.WrappedComponent || this.props.WrappedComponent.match(/^h\d$/) ? 'heading' : '';

    const modifiers = {
      [is]: !!!this.props.WrappedComponent,
      'no-margin': !!noMargin,
    };

    const classes = new BEM(baseClass);

    const label: React.ReactNode = !!text ? <Span text={text} maxTextLength={maxTextLength} /> : children;

    return (
      <WrappedComponent {...classes('', modifiers, headingClass) } style={style}>
        {icon}
        {hyperLinkProps ? (
          <LinkButton to={hyperLinkProps.href} external={hyperLinkProps.external} variant="text">
            {label}
          </LinkButton>
        ) : label}
      </WrappedComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/text/Heading/index.tsx